import { render, staticRenderFns } from "./editTablePayway-dialog.vue?vue&type=template&id=3b6510a2&"
import script from "./editTablePayway-dialog.vue?vue&type=script&lang=js&"
export * from "./editTablePayway-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports